import {InputAdornment} from '@mui/material'
import PropTypes from 'prop-types'
import {
  StyledContainer,
  StyledDisclaimerPaper,
  StyledDiscTypography,
  StyledDivInput,
  StyledDivPaper,
  StyledExportDiv,
  StyledFormControlChatInput,
  StyledInput,
  StyledNewChatContainer,
  StyledSendOutlined
} from '../ChatViewStyles'
import chatbotConfig from '../../../../../../configs/askGPChatViewConfig.json'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import theme from '../../../../../../themes'
import NewChat from './NewChat'
import CopyContent from '../../../../../Common/CopyContent/CopyContentIndex'
import ExportContent from '../../../../../Common/ExportContent/ExportContent'

const ChatInput = ({
  searchWord,
  setSearchWord,
  handleSearch,
  sendButtonRef,
  loader,
  showDisclaimer,
  handleNewChat,
  responseData,
  agent
}) => {
  const rawText = responseData.at(-1)?.data?.text?.replaceAll(/`+|\*+|---|#/g, '') || ''

  const removeTextBeforeSubject = (text) => {
    if (!text) return text
    const colonIndex = text.indexOf(':')
    return colonIndex === -1 ? text : text.substring(colonIndex + 1).trimStart()
  }

  return (
    <StyledDivInput>
      {showDisclaimer && (
        <StyledContainer>
          <StyledNewChatContainer>
            <NewChat loader={loader} handleNewChat={handleNewChat} />
          </StyledNewChatContainer>
          {agent === 'EngagementAgent' && (
            <StyledExportDiv>
              <CopyContent unparsedData={removeTextBeforeSubject(rawText)} marginRequired={true} />
              <ExportContent content={removeTextBeforeSubject(rawText)} />
            </StyledExportDiv>
          )}
        </StyledContainer>
      )}
      {showDisclaimer && (
        <StyledDisclaimerPaper elevation={0}>
          <StyledDivPaper>
            <ErrorOutlineIcon sx={{marginTop: '2px'}} />
            <StyledDiscTypography>
              Responses are generated using generative AI technology. Please review to confirm accuracy.
            </StyledDiscTypography>
          </StyledDivPaper>
        </StyledDisclaimerPaper>
      )}
      <StyledFormControlChatInput variant="filled">
        <StyledInput
          maxRows={4}
          multiline={true}
          value={searchWord}
          disableUnderline={true}
          placeholder="How can I help you today?"
          inputProps={{
            maxLength: chatbotConfig.maxPromptCharLength
          }}
          onChange={(event) => {
            setSearchWord(event.target.value)
          }}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && !loader && searchWord.trim()) {
              handleSearch()
              event.preventDefault()
            }
          }}
          endAdornment={
            <InputAdornment
              position="end"
              sx={{paddingTop: '7px', cursor: (loader || !searchWord.trim()) && 'pointer'}}
            >
              <StyledSendOutlined
                ref={sendButtonRef}
                onClick={!loader && searchWord.trim() && handleSearch}
                style={{
                  pointerEvents: loader || !searchWord.trim() ? 'none' : 'auto',
                  color: theme.palette.primary.main
                }}
              />
            </InputAdornment>
          }
        />
      </StyledFormControlChatInput>
    </StyledDivInput>
  )
}

ChatInput.propTypes = {
  searchWord: PropTypes.string.isRequired,
  setSearchWord: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  sendButtonRef: PropTypes.object,
  loader: PropTypes.bool.isRequired,
  showDisclaimer: PropTypes.bool.isRequired,
  handleNewChat: PropTypes.func.isRequired,
  responseData: PropTypes.array.isRequired,
  agent: PropTypes.string.isRequired
}

export default ChatInput
